import {Swiper, SwiperSlide} from 'swiper/react'

import 'swiper/css';
import 'swiper/css/pagination';
import {Pagination} from "swiper/modules"
import {getImageServerMediumUrl, getUserAvatar} from "../../actions/environment";
import {PLACEHOLDER as PLAY_BUTTON} from "../../static";
import {useLanguage} from "../configuration/configuration";
import React, {useState} from "react";
import PlayVideoReel from './play-video-reel'

const VideoReel = ({enrichedMedia}) => {
    const [playVideoReel, setPlayVideoReel] = useState(false);

    const resolveThumbnail = () => {
        return enrichedMedia.thumbnail ? getImageServerMediumUrl(enrichedMedia.thumbnail) : null;
    }

    const resolveUserAvatar = () => {
        return enrichedMedia.state != null &&  enrichedMedia.state === 'SHARED'
            ? enrichedMedia.from : enrichedMedia.user;
    }

    const onPlayVideoReel = (event) => {
        event.preventDefault();
        setPlayVideoReel(!playVideoReel);
    }

    const renderVideo = () => {
        return <a href='' onClick={onPlayVideoReel}>
            <div style={{position: "relative"}}>
                <img src={PLAY_BUTTON} data-src={resolveThumbnail()}/>
            </div>
        </a>
    }

    return <div className="video-reel-player">
        <img className='video-reel-avatar' src={getUserAvatar(resolveUserAvatar())}/>
        <div className='youtube-player'>
            {renderVideo()}
        </div>
        {playVideoReel &&
            <PlayVideoReel enrichedMedia={enrichedMedia} isOpen={playVideoReel} setIsOpen={setPlayVideoReel}/>}
    </div>
}

const VideoReelContainer = ({posts: posts}) => {
    const Lang = useLanguage();

    const handleClick = (event) => {
        event.preventDefault();
        console.log("Clicked", event.target.dataset.mediaId);
    }

    const gatherEnrichedMedia = (posts) => {
        const medialist = []
        posts.forEach(post => {
            post.media.forEach(media => {
                if (media.type === "VIDEO") {
                    const enrichedMedia = {
                        ...media,
                        'text': post.text,
                        'user': post.user,
                        'access': post.access,
                        'from': post.from,
                        'state': post.state
                    }
                    medialist.push(enrichedMedia)
                }
            })
        })
        return medialist;
    }

    const renderReels = (medialist) => {
        return medialist.map(enrichedMedia =>
            <SwiperSlide key={enrichedMedia.id}>
                <VideoReel enrichedMedia={enrichedMedia} key={enrichedMedia.id}/>
            </SwiperSlide>
        )
    }

    const medialist = gatherEnrichedMedia(posts);
    if (!medialist || medialist.length === 0) return null;

    return <div className="video-reel-container mt-2">
        <Swiper
            slidesPerView={'auto'}
            centeredSlides={true}
            spaceBetween={15}
            pagination={{
                clickable: true,
            }}
            modules={[Pagination]}
            className="mySwiper"
        >
            <SwiperSlide onClick={handleClick} data-media-id="video1">
                <span className='px-1'>{Lang.reels.slider.first}</span>
            </SwiperSlide>
            {renderReels(medialist)}
            <SwiperSlide onClick={handleClick} data-media-id="videolast">
                <span className='mx-1'>{Lang.reels.slider.last}</span>
            </SwiperSlide>
        </Swiper>
    </div>
}

export default VideoReelContainer;